import { Environment } from '@highereducation/dynamic-experience';
import { env } from '@hen-site/env';

const ENVIRONMENT_MAP: Record<string, Environment> = {
  prd: 'prod',
  prod: 'prod',
  production: 'prod',
  int: 'int',
  integration: 'int',
  dev: 'int',
  development: 'int',
};

/** Environments operators may target via NEXT_PUBLIC_DYNAMIC_EXPERIENCE_ENV. */
const OVERRIDE_ENVIRONMENTS: readonly Environment[] = [
  'local',
  'dev',
  'int',
  'beta',
  'prod',
];

export const getEnvironment = (): Environment => {
  const override = env.dynamicExperienceEnvironment.trim() as Environment;
  if (OVERRIDE_ENVIRONMENTS.includes(override)) return override;

  return ENVIRONMENT_MAP[env.environment] ?? 'int';
};
